const router = function (permissions) {
  return ({
      path: 'profile',
      component: () => import('@/views/User/UserProfile.vue'),
      meta: { permissions, title: 'Perfil do Usuário' },
    })
}

export default {
  router,
}
